
import React from 'react';
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="w-10 h-10 rounded-lg bg-leo-blue flex items-center justify-center text-white font-bold text-xl">
        Mo
      </div>
      <span className="font-bold text-lg">paossi</span>
    </div>
  );
};

export default Logo;
